import { Auth0ClientOptions } from "@auth0/auth0-spa-js";

export const AUTH0_SETTINGS: Auth0ClientOptions = {
  domain: 'login.digiamerica.us',
  clientId: 'QPiJFeKVVMzhZjTgdDsvMkFOR039moCI',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'api://api.digiamerica.us', // your API identifier
    scope: 'openid profile email',
  }
};

export const SALES_REPORT_ENDPOINT = "https://api.digiamerica.us/v2/sales-report/";